import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAsyncAction } from '../../hooks/useAsyncAction';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { loading, error, run } = useAsyncAction();

  async function handleSubmit(e) {
    e.preventDefault();
    await run(async () => {
      const res = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');
      navigate('/admin/novels');
    });
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <h1 style={s.heading}>Admin Login</h1>
        <p style={s.sub}>Classroom.Bingo · Platform Owner</p>
        <form onSubmit={handleSubmit}>
          <label style={s.label}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)}
            required style={s.input} />
          <label style={s.label}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            required style={s.input} />
          {error && <p style={s.error}>{error}</p>}
          <button type="submit" disabled={loading} style={s.btn}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    backgroundColor: '#f3f4f6', fontFamily: 'system-ui, sans-serif' },
  card: { backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px',
    padding: '36px 32px', width: '100%', maxWidth: '360px' },
  heading: { fontSize: '22px', fontWeight: '700', color: '#111827', margin: '0 0 4px' },
  sub: { fontSize: '13px', color: '#6b7280', margin: '0 0 24px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '4px' },
  input: { display: 'block', width: '100%', padding: '9px 12px', border: '1px solid #d1d5db',
    borderRadius: '6px', fontSize: '14px', marginBottom: '14px', boxSizing: 'border-box' },
  error: { color: '#dc2626', fontSize: '13px', margin: '0 0 12px' },
  btn: { width: '100%', padding: '10px', backgroundColor: '#1a1a2e', color: '#fff',
    border: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '15px', cursor: 'pointer' },
};
